class blockFilters extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('button');
    if (!button || !this.contains(button)) return;

    const alreadyActive = button.classList.contains('is-active');
    this.querySelectorAll('button.is-active').forEach(btn => btn.classList.remove('is-active'));

    let filter;
    if (alreadyActive) {
      filter = 'all';
    } else {
      button.classList.add('is-active');
      filter = button.dataset.filter ?? button.getAttribute('filter');
    }
    if (!filter) return;

    const target = filter.trim().toLowerCase();
    const sectionId = this.dataset.sectionId;
    const scope = sectionId ? document.getElementById(sectionId) : document;

    const items = scope.querySelectorAll('[data-category]');
    if (target === 'all') {
      items.forEach(item => { item.style.display = ''; });
      return;
    }

    items.forEach(item => {
      const raw = item.dataset.category ?? item.getAttribute('data-category') ?? '';
      // split on commas; trim; lowercase; drop empties
      const cats = raw.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
      item.style.display = cats.includes(target) ? '' : 'none';
    });

    this.dispatchEvent(new CustomEvent('filter:applied', {
      detail: { filter: target, sectionId },
      bubbles: true,
      composed: true
    }));
  }
}

customElements.define('block-filters', blockFilters);
